// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"957a104b","468":"957a104b","575":"957a104b"}[chunkId] + ".chunk.css";
};